// Product ID to name mappings for all forms
// Used to convert legacy cache format (stored as numbers) to actual product names

// Livingston Products mapping
const LIVINGSTON_PRODUCTS: Record<string, { name: string; code: string; price: number; category: string }> = {
  '1': { name: 'Bachelor Button Choice', code: '143874', price: 2.99, category: 'flower' },
  '2': { name: 'Cardinal Climber', code: '141002', price: 2.99, category: 'flower' },
  '3': { name: 'Columbine McKana\'s Giant Mix', code: '143875', price: 2.99, category: 'flower' },
  '4': { name: 'Cosmos Sensation Picotee', code: '143877', price: 2.99, category: 'flower' },
  '5': { name: 'Delphinium Pacific Giants Mix', code: '141006', price: 2.99, category: 'flower' },
  '6': { name: 'Echinicea Coneflower Purple', code: '141003', price: 2.99, category: 'flower' },
  '7': { name: 'Larkspur Giant Imperial', code: '143131', price: 2.99, category: 'flower' },
  '8': { name: 'Marigold Petite', code: '143882', price: 2.99, category: 'flower' },
  '9': { name: 'Poppy Oriental Red', code: '143885', price: 2.99, category: 'flower' },
  '10': { name: 'Viola Johnny Jump Up', code: '143886', price: 2.99, category: 'flower' },
  '11': { name: 'Zinnia Cut & Come Again', code: '141025', price: 2.99, category: 'flower' },
  '12': { name: 'Zinnia Lilliput', code: '141026', price: 2.99, category: 'flower' },
  '13': { name: 'Zinnia State Fair', code: '138885', price: 2.99, category: 'flower' },
  '14': { name: 'Morning Glory Blue Picotee', code: '141029', price: 3.49, category: 'flower' },
  '15': { name: 'Morning Glory Choice', code: '138828', price: 3.49, category: 'flower' },
  '16': { name: 'Bean Blue Lake (B)', code: '140740', price: 2.99, category: 'vegetable' },
  '17': { name: 'Bean Blue Lake Stringless (P)', code: '140741', price: 2.99, category: 'vegetable' },
  '18': { name: 'Bean Bountiful (B)', code: '142073', price: 2.99, category: 'vegetable' },
  '19': { name: 'Bean Cherokee Wax (B)', code: '142074', price: 2.99, category: 'vegetable' },
  '20': { name: 'Bean Kentucky Wonder (B)', code: '142075', price: 2.99, category: 'vegetable' },
  '21': { name: 'Bean Provider (B)', code: '142072', price: 2.99, category: 'vegetable' },
  '22': { name: 'Bean Topcrop (B)', code: '140750', price: 2.99, category: 'vegetable' },
  '23': { name: 'Beet Bull\'s Blood', code: '142077', price: 2.99, category: 'vegetable' },
  '24': { name: 'Cabbage Golden Acre', code: '142078', price: 2.99, category: 'vegetable' },
  '25': { name: 'Cantaloupe Hearts Of Gold', code: '142080', price: 2.99, category: 'vegetable' },
  '26': { name: 'Corn Double Sweet', code: '143876', price: 2.99, category: 'vegetable' },
  '27': { name: 'Cucumber Early Fortune', code: '142083', price: 2.99, category: 'vegetable' },
  '28': { name: 'Cucumber Marketmore', code: '142084', price: 2.99, category: 'vegetable' },
  '29': { name: 'Cucumber Muncher Burpless', code: '138983', price: 2.99, category: 'vegetable' },
  '30': { name: 'Herb Basil Genovese', code: '143878', price: 2.99, category: 'vegetable' },
  '31': { name: 'Herb Dill Mammoth', code: '143879', price: 2.99, category: 'vegetable' },
  '32': { name: 'Lettuce Baby Romaine', code: '143880', price: 2.99, category: 'vegetable' },
  '33': { name: 'Lettuce Bibb', code: '142085', price: 2.99, category: 'vegetable' },
  '34': { name: 'Lettuce Select Salad Blend', code: '143881', price: 2.99, category: 'vegetable' },
  '35': { name: 'Lettuce Livingston\'s Mix', code: '142086', price: 2.99, category: 'vegetable' },
  '36': { name: 'Lettuce Slobolt', code: '142088', price: 2.99, category: 'vegetable' },
  '37': { name: 'Lettuce Tennis Ball', code: '142089', price: 2.99, category: 'vegetable' },
  '38': { name: 'Onion Red Wethersfield', code: '142090', price: 2.99, category: 'vegetable' },
  '39': { name: 'Onion White Lisbon Bunching', code: '142091', price: 2.99, category: 'vegetable' },
  '40': { name: 'Pea Dwarf Grey Sugar', code: '142092', price: 2.99, category: 'vegetable' },
  '41': { name: 'Pea Early Frosty', code: '142093', price: 2.99, category: 'vegetable' },
  '42': { name: 'Pea Oregon Sugar Pod II', code: '143883', price: 2.99, category: 'vegetable' },
  '43': { name: 'Pepper Bell Color Mix', code: '143884', price: 2.99, category: 'vegetable' },
  '44': { name: 'Pepper King Of The North', code: '142095', price: 2.99, category: 'vegetable' },
  '45': { name: 'Spinach America', code: '142098', price: 2.99, category: 'vegetable' },
  '46': { name: 'Squash Cocozelle', code: '142099', price: 2.99, category: 'vegetable' },
  '47': { name: 'Squash Table King Acorn', code: '142100', price: 2.99, category: 'vegetable' },
  '48': { name: 'Tomato Abe Lincoln', code: '142101', price: 2.99, category: 'vegetable' },
  '49': { name: 'Tomato Baby Roma', code: '142102', price: 2.99, category: 'vegetable' },
  '50': { name: 'Tomato Brandywine Red', code: '142105', price: 2.99, category: 'vegetable' },
  '51': { name: 'Tomato Marglobe', code: '142103', price: 2.99, category: 'vegetable' },
  '52': { name: 'Tomato Red Cherry Large', code: '142106', price: 2.99, category: 'vegetable' },
  '53': { name: 'Watermelon Black Diamond', code: '142108', price: 2.99, category: 'vegetable' },
  '54': { name: 'Watermelon Dixie Queen', code: '142109', price: 2.99, category: 'vegetable' },
  '55': { name: 'Watermelon Moon & Stars Red', code: '142110', price: 2.99, category: 'vegetable' },
  '56': { name: 'Zucchini Black Beauty', code: '143887', price: 2.99, category: 'vegetable' },
  '57': { name: 'Zucchini Bush', code: '143888', price: 2.99, category: 'vegetable' },
  '58': { name: 'Pumpkin Big Moon', code: '139068', price: 3.49, category: 'vegetable' },
  '59': { name: 'Pumpkin Jack-Be-Little', code: '139081', price: 3.49, category: 'vegetable' },
  '60': { name: 'Pumpkin Livingston\'s Pie', code: '142096', price: 3.49, category: 'vegetable' },
};

// Helper functions for Livingston products
export const getLivingstonProductName = (id: string): string => {
  return LIVINGSTON_PRODUCTS[id]?.name || `Livingston Product ${id}`;
};

export const getLivingstonProductCode = (id: string): string => {
  return LIVINGSTON_PRODUCTS[id]?.code || `L-${id}`;
};

export const getLivingstonProductPrice = (id: string): number => {
  return LIVINGSTON_PRODUCTS[id]?.price || 2.99;
};

export const getLivingstonProductCategory = (id: string): string => {
  return LIVINGSTON_PRODUCTS[id]?.category || 'livingston';
};

// Helper to check if a product name is generic (needs to be mapped)
export const isGenericProductName = (name: string): boolean => {
  return /^(Livingston|Heritage|Flower|Vegetable)\s+Product\s+\d+$/.test(name);
};

// Helper to map generic product names to actual names from StoreOrders
// This fixes items that were saved with generic names
export const mapGenericProductName = (name: string, id: string, category: string): string => {
  if (category === 'livingston' || name.startsWith('Livingston Product')) {
    return getLivingstonProductName(id);
  }
  // For other categories, we'd need their product mappings
  // For now, return the name as-is if it's not generic
  return name;
};

